<template>
    <div class="tw-p-1 tw-w-full tw-bg-emerald-600 tw-text-xs tw-text-white tw-text-center">
        Caisse ouverte le: Mercredi 16 Août 2023 à 10:59
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>